export default function getIndex(i: number, l: number): number {
  if (i < 0) return 0;
  if (i > l - 1) return l - 1;
  return i % l;
}
